import axios from 'axios';
import Cookies from 'js-cookie';
import { FHIR_COOKIE_KEY } from 'src/careflow/ph-core/fhir-client/fhir-base/clients/axios';
import { config } from 'src/config';

const axiosFhirInstance = axios.create({
  baseURL: config.fhirApiBaseUrl,
  headers: {
    Authorization: `Bearer ${Cookies.get(FHIR_COOKIE_KEY)}`,
  },
});

if (config.fhirTenantId) {
  axiosFhirInstance.defaults.headers.common['X-Tenant-Id'] = config.fhirTenantId;
}

axiosFhirInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosFhirInstance;
